module.exports = __webpack_public_path__ + "static/img/amount.1c6bb4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/amount.png
// module id = 1211
// module chunks = 173